import { Region } from '~/components/home-page/cities-slider';
import CitiesDropdown from './cities-dropdown';
import MobileCitiesDropdown from './mobile-dropdown';
import cn from 'classnames';
export interface CitiesDropdownProps {
   // eslint-disable-next-line no-unused-vars
   onChange: (href: string, target?: HTMLLIElement) => void;
   defaultValue?: string;
   regions?: Region[];
   desktopMode?: boolean;
}

const CitiesDropdowns = (props: CitiesDropdownProps) => {
   return (
      <div>
         <div className={cn(props.desktopMode ? 'hidden' : 'block tablet:hidden')}>
            <MobileCitiesDropdown {...props} />
         </div>
         <div className={cn(props.desktopMode ? 'block' : 'hidden tablet:block')}>
            <CitiesDropdown {...props} />
         </div>
      </div>
   );
};

export default CitiesDropdowns;
